import type { AnswerValue } from "@/api/types";

/** The parts of a question needed to show an answer (a template question or a compare entry). */
export type AnswerShape = {
  type: string;
  options?: { value: string; label: string }[];
  unit?: string | null;
};
export type AnswerLabels = { yes: string; no: string; fileRemoved: string };
type Value = AnswerValue | null | undefined;

export function isBlank(v: Value): v is null | undefined | "" | [] {
  return v === null || v === undefined || v === "" || (Array.isArray(v) && v.length === 0);
}

/**
 * Plain-text, read-only rendering of an answer: option labels (falling back to the stored value
 * when an option no longer exists), Yes/No, numbers with their unit, file names. "" when blank.
 */
export function answerText(q: AnswerShape, v: Value, fileName: (id: string) => string | undefined, labels: AnswerLabels): string {
  if (isBlank(v)) return "";
  if (typeof v === "boolean") return v ? labels.yes : labels.no;
  if (q.type === "file_upload" && Array.isArray(v)) return v.map((id) => fileName(id) ?? labels.fileRemoved).join("; ");
  const label = (s: string) => q.options?.find((o) => o.value === s)?.label ?? s;
  if (Array.isArray(v)) return v.map(label).join("; ");
  if (typeof v === "number") return q.unit ? `${v} ${q.unit}` : String(v);
  return label(v);
}
